/**
 * OMON-290: the lazy-archive fetch plan — pure logic, no Firebase imports, so
 * it is unit-testable the same way live-tail.ts / router-parse.ts are.
 *
 * The connect swimlane starts on the most recent month and digs out the rest
 * of the last year behind it. The server hard-rejects windows over 60 days
 * (`_MAX_WINDOW_DAYS` in omon-api routes/connect.py), so the year is only
 * reachable as a sequence of sub-cap requests.
 */

/** How far back the lazy archive digs, total. */
export const ARCHIVE_TOTAL_DAYS = 365;
/** Per-request span for archive chunks — MUST stay under the server's 60d cap. */
export const ARCHIVE_CHUNK_DAYS = 56;

/**
 * Plan the archive fetches — newest-first chunks of at most `chunkMs`, walking
 * DOWN from `fromMs` (exclusive top) to `floorMs`. Newest-first because the
 * nearer past is what demos actually scrub into; the deep past streams in
 * behind it.
 */
export function planArchiveChunks(
  fromMs: number,
  floorMs: number,
  chunkMs: number = ARCHIVE_CHUNK_DAYS * 86_400_000,
): Array<{ startMs: number; endMs: number }> {
  const out: Array<{ startMs: number; endMs: number }> = [];
  let top = fromMs;
  while (top > floorMs) {
    const startMs = Math.max(top - chunkMs, floorMs);
    out.push({ startMs, endMs: top });
    top = startMs;
  }
  return out;
}
